/**
 * GraphQL Query
 * 注文画面
 */

/**
 * 注文一覧
 */

export const GRAPH_QL_QUERY_ORDER_LIST =
`
  query {
    latestOrders( ? ) {
      edges {
        node {
          id
          uuid
          site {
            code
            name
          }
          orderNo
          orderDatetime
          orderer {
            lastName
            secondName
            firstName
            suffix
            lastNameKana
            firstNameKana
          }
          qty {
            current
            ordered
            unallocated
            pending
            preExport
            preReExport
            canceled
            exported
            shipped
            unshipped
            inshipCanceled
            transfer
            receiveShipped
            receiveFixed
            exOut
            exOutExported
            exOutShipped
            exOutUnshipped
            exOutFixed
            exIn
            exInShipped
            exInFixed
          }
          shipments (isFromList: 1) {
            shipmentId
            leadtime
            address {
              postalCode
              stateCode
              city
              address1
              address2
            }
            items {
              lineitemText
              qty {
                current
                ordered
                unallocated
                pending
                preExport
                preReExport
                canceled
                exported
                shipped
                unshipped
                inshipCanceled
                transfer
                receiveShipped
                receiveFixed
                exOut
                exOutExported
                exOutShipped
                exOutUnshipped
                exOutFixed
                exIn
                exInShipped
                exInFixed
              }
              isBundle
              isShipment
              bundleItems {
                isBundle
                isShipment
                qty {
                  current
                  ordered
                  unallocated
                  pending
                  preExport
                  preReExport
                  canceled
                  exported
                  shipped
                  unshipped
                  inshipCanceled
                  transfer
                  receiveShipped
                  receiveFixed
                  exOut
                  exOutExported
                  exOutShipped
                  exOutUnshipped
                  exOutFixed
                  exIn
                  exInShipped
                  exInFixed
                }
              }
            }
          }
          payments {
            paymentMethod {
              code
              name
              nameAbbr
              methodType
              isImmediatable
            }
            amount
            transactionId1
            isPaid
            editableType
            paymentSets {
              processCode
              statusCode
              isCancellable
            }
          }
          isPaid
          orderTotalPrice {
            net
            gross
          }
          currency
          redResult
          notes {
            id
            uuid
            subject
            note
            noteType
            createdAt
            updatedAt
          }
          exports {
            id
            closedAt
            exportedAt
            isAvailable
          }
          paymentSets {
            statusCode
            isReserved
          }
          exchanges {
            id
            srcOrderItem {
              uuid
              auid
            }
            destOrderItem {
              uuid
              auid
            }
            quantity
            preExportQty
            exportedQty
            shippedQty
            unshippedQty
            completedQty
            inshipCanceledQty
            isStockout
          }
          lastUpdatedAt
          attributes {
            attrId
            attrValue
          }
        }
      }
      totalCount
    }
  }
`

/**
 * 注文詳細
 */
export const GRAPH_QL_QUERY_ORDER_DETAIL =
`
  query {
    latestOrder( ? ) {
      id
      uuid
      site {
        code
        name
      }
      orderNo
      revision
      orderDatetime
      customer {
        uuid
        attributes {
          attrId
          attrValue
        }
      }
      customerNo
      customerEmail
      orderer {
        lastName
        secondName
        firstName
        suffix
        lastNameKana
        firstNameKana
        phone
        email
      }
      address {
        countryCode
        postalCode
        stateCode
        city
        address1
        address2
        suite
        postbox
      }
      qty {
        current
        ordered
        unallocated
        pending
        preExport
        preReExport
        canceled
        exported
        shipped
        unshipped
        inshipCanceled
        transfer
        receiveShipped
        receiveFixed
        exOut
        exOutExported
        exOutShipped
        exOutUnshipped
        exOutFixed
        exIn
        exInShipped
        exInFixed
      }
      shipments {
        id
        uuid
        shipmentId
        receiver {
          lastName
          secondName
          firstName
          suffix
          lastNameKana
          firstNameKana
          phone
        }
        address {
          countryCode
          postalCode
          stateCode
          city
          address1
          address2
          suite
          postbox
        }
        shippingMethod
        deliveryDate
        deliveryTime
        giftType
        giftMessage
        exportableAt
        leadtime
        scheduledShippingAt
        items {
          id
          uuid
          auid
          position
          lineitemText
          basePrice {
            net
            gross
          }
          price {
            net
            gross
          }
          taxRate
          orderAdjustPrice {
            net
            gross
          }
          adjustedPrice {
            net
            gross
          }
          priceAdjustments {
            id
            uuid
            position
            promotionId
            campaignId
            couponId
            reasonCode
            lineitemText
            basePrice {
              net
              gross
            }
            price {
              net
              gross
            }
            attributes {
              attrId
              attrValue
            }
          }
          productId
          brand
          productName
          colorName
          sizeName
          qty {
            current
            ordered
            unallocated
            pending
            preExport
            preReExport
            canceled
            exported
            shipped
            unshipped
            inshipCanceled
            transfer
            receiveShipped
            receiveFixed
            exOut
            exOutExported
            exOutShipped
            exOutUnshipped
            exOutFixed
            exIn
            exInShipped
            exInFixed
          }
          unit
          orderItemType
          retailPrice
          isSale
          isGift
          point
          consumedPoint
          sku {
            product {
              taxes (?) {
                type
                rate
              }
            }
          }
          isBundle
          preparingShipmentStartedAt
          releaseDatetime
          isShipment
          bundleItems {
            id
            uuid
            auid
            position
            lineitemText
            productId
            preparingShipmentStartedAt
            releaseDatetime
            isShipment
            retailPrice
            qty {
              current
              ordered
              unallocated
              pending
              preExport
              preReExport
              canceled
              exported
              shipped
              unshipped
              inshipCanceled
              transfer
              receiveShipped
              receiveFixed
              exOut
              exOutExported
              exOutShipped
              exOutUnshipped
              exOutFixed
              exIn
              exInShipped
              exInFixed
            }
            exchanges {
              id
              uuid
              orderExport {
                id
              }
              srcOrderItem {
                id
                uuid
                auid
                position
                lineitemText
                productId
              }
              destOrderItem {
                id
                uuid
                auid
                position
                lineitemText
                productId
              }
              quantity
              preExportQty
              exportedQty
              shippedQty
              unshippedQty
              completedQty
              inshipCanceledQty
              isStockout
            }
            attributes {
              attrId
              attrValue
            }
          }
          optionItems{
            id
            uuid
            auid
            position
            lineitemText
            productId
            qty {
              current
              ordered
              unallocated
              pending
              preExport
              preReExport
              canceled
              exported
              shipped
              unshipped
              inshipCanceled
              transfer
              receiveShipped
              receiveFixed
              exOut
              exOutExported
              exOutShipped
              exOutUnshipped
              exOutFixed
              exIn
              exInShipped
              exInFixed
            }
            exchanges {
              id
              uuid
              orderExport {
                id
              }
              srcOrderItem {
                id
                uuid
                auid
                position
                lineitemText
                productId
              }
              destOrderItem {
                id
                uuid
                auid
                position
                lineitemText
                productId
              }
              quantity
              preExportQty
              exportedQty
              shippedQty
              unshippedQty
              completedQty
              inshipCanceledQty
              isStockout
            }
          }
          shipment {
            id
            uuid
          }
          exchanges {
            id
            uuid
            orderExport {
              id
            }
            srcOrderItem {
              id
              uuid
              auid
              position
              lineitemText
              productId
            }
            destOrderItem {
              id
              uuid
              auid
              position
              lineitemText
              productId
            }
            quantity
            preExportQty
            exportedQty
            shippedQty
            unshippedQty
            completedQty
            inshipCanceledQty
            isStockout
          }
          salesItems {
            salesDatetime
            adjustedPrice {
              net
              gross
            }
            basePrice {
              net
              gross
            }
            qty { 
              current
              ordered
              canceled
              shipped
              transfer
              exOut
              exOutFixed
              exIn
              exInFixed 
            }
          }
          attributes {
            attrId
            attrValue
          }
        }
        giftItems {
          id
          uuid
          auid
          position
          lineitemText
          basePrice {
            net
            gross
          }
          price {
            net
            gross
          }
          taxRate
          productId
          priceAdjustments {
            id
            uuid
            position
            promotionId
            campaignId
            couponId
            reasonCode
            lineitemText
            basePrice {
              net
              gross
            }
            price {
              net
              gross
            }
            attributes {
              attrId
              attrValue
            }
          }
          shipment {
            id
            uuid
          }
          attributes {
            attrId
            attrValue
          }
        }
        shippingItems {
          id
          uuid
          auid
          position
          lineitemText
          basePrice {
            net
            gross
          }
          price {
            net
            gross
          }
          taxRate
          productId
          priceAdjustments {
            id
            uuid
            position
            promotionId
            campaignId
            couponId
            reasonCode
            lineitemText
            basePrice {
              net
              gross
            }
            price {
              net
              gross
            }
            attributes {
              attrId
              attrValue
            }
          }
          shipment {
            id
            uuid
          }
          attributes {
            attrId
            attrValue
          }
        }
        attributes {
          attrId
          attrValue
        }
      }
      payments {
        id
        uuid
        auid
        position
        paymentMethod {
          code
          name
          nameAbbr
          methodType
          isImmediatable
          isPoint
        }
        amount
        transactionId1
        transactionId2
        transactionId3
        isPaid
        paidAt
        isProcessed
        editableType
        paymentSets {
          id
          uuid
          latestOrder {
            id
            uuid
          }
          orderPayment {
            id
            uuid
            paymentMethod {
              code
              name
              nameAbbr
              methodType
              isImmediatable
            }
            amount
            transactionId1
            transactionId2
            transactionId3
            isPaid
          }
          processCode
          statusCode
          isReserved
          isCancellable
          processesAt
          processedAt
          amount
          requestedAt
          responsedAt
          responseCode
          responseKey
          responseKey2
          errorReasonCode
          createdAt
          updatedAt
          attributes {
            attrId
            attrValue
          }
        }
        attributes {
          attrId
          attrValue
        }
      }
      isPaid
      orderTotalPrice {
        net
        gross
      }
      merchandisePriceAdjustments {
        id
        uuid
        position
        promotionId
        campaignId
        couponId
        reasonCode
        lineitemText
        basePrice {
          net
          gross
        }
        price {
          net
          gross
        }
        isPoint
        attributes {
          attrId
          attrValue
        }
      }
      invoiceNo
      currency
      taxation
      businessType
      orderType
      channelType
      redResult
      point
      consumedPoint
      notes {
        id
        uuid
        subject
        note
        noteType
        createdAt
        updatedAt
      }
      logs {
        id
        logType
        changeLog
        tableId
        refid
        account
        createdAt
      }
      exports {
        id
        uuid
        orderExportShippedNo
        order {
          id
        }
        items {
          id
          position
          orderItem {
            id
            uuid
            auid
            position
            lineitemText
            productId
            brand
            productName
            colorName
            sizeName
            shipment {
              shipmentId
              shippingMethod
            }
          }
          quantity
          exportType
        }
        exportableAt
        closedAt
        exportedAt
        shippeds {
          id
        }
        exchanges {
          id
          uuid
          srcOrderItem {
            id
            uuid
            auid
            position
            lineitemText
            productId
            brand
            productName
            colorName
            sizeName
          }
          destOrderItem {
            id
            uuid
            auid
            position
            lineitemText
            productId
            brand
            productName
            colorName
            sizeName
          }
          quantity
          preExportQty
          exportedQty
          shippedQty
          unshippedQty
          completedQty
          inshipCanceledQty
          isStockout
        }
        isAvailable
        createdAt
        attributes {
          attrId
          attrValue
        }
      }
      shippeds {
        id
        uuid
        orderExportShippedNo
        slipType
        slipTypeDetail
        slipNo
        slipNoSuffix
        slipDatetime
        correctType
        trackingNumber
        items {
          id
          position
          productId
          requestQuantity
          quantity
          reasonCode
          orderItem {
            id
            uuid
            position
            lineitemText
          }
          attributes {
            attrId
            attrValue
          }
        }
        latestOrder {
          id
          uuid
          items {
            id
            uuid
            position
            qty {
              exOutUnshipped
            }
          }
        }
        order {
          items {
            id
            qty {
              exOutUnshipped
            }
          }
        }
        orderExport {
          id
          uuid
          items {
            id
            position
            quantity
            exportType
          }
        }
        orderShipment {
          shipmentId
          shippingMethod
        }
        createdAt
        attributes {
          attrId
          attrValue
        }
      }
      exchanges {
        orderExport {
          id
        }
        srcOrderItem {
          id
          uuid
          auid
          position
          lineitemText
          productId
          brand
          productName
          colorName
          sizeName
        }
        destOrderItem {
          id
          uuid
          auid
          position
          lineitemText
          productId
          brand
          productName
          colorName
          sizeName
        }
        quantity
        preExportQty
        exportedQty
        shippedQty
        unshippedQty
        completedQty
        inshipCanceledQty
        isStockout
      }
      paymentSets {
        id
        uuid
        latestOrder {
          id
          uuid
        }
        orderPayment {
          id
          uuid
          auid
          paymentMethod {
            code
            name
            nameAbbr
            methodType
            isImmediatable
          }
          amount
          transactionId1
          transactionId2
          transactionId3
          isPaid
        }
        processCode
        statusCode
        isReserved
        isCancellable
        processesAt
        processedAt
        amount
        requestedAt
        responsedAt
        response
        responseCode
        responseKey
        responseKey2
        errorReasonCode
        createdAt
        updatedAt
        attributes {
          attrId
          attrValue
        }
      }
      attributes {
        attrId
        attrValue
      }
      isLatest
      lastUpdatedAt
      updatedAt
      histories {
        id
        uuid
        site {
          code
          name
        }
        orderNo
        orderDatetime
        customerNo
        customerEmail
        orderer {
          lastName
          secondName
          firstName
          suffix
          lastNameKana
          firstNameKana
          phone
          email
        }
        address {
          countryCode
          postalCode
          stateCode
          city
          address1
          address2
          suite
          postbox
        }
        qty {
          current
          ordered
          unallocated
          pending
          preExport
          preReExport
          canceled
          exported
          shipped
          unshipped
          inshipCanceled
          transfer
          receiveShipped
          receiveFixed
          exOut
          exOutExported
          exOutShipped
          exOutUnshipped
          exOutFixed
          exIn
          exInShipped
          exInFixed
        }
        shipments {
          id
          uuid
          shipmentId
          receiver {
            lastName
            secondName
            firstName
            suffix
            lastNameKana
            firstNameKana
            phone
          }
          address {
            countryCode
            postalCode
            stateCode
            city
            address1
            address2
            suite
            postbox
          }
          shippingMethod
          deliveryDate
          deliveryTime
          giftType
          giftMessage
          exportableAt
          leadtime
          scheduledShippingAt
          items {
            id
            uuid
            auid
            position
            lineitemText
            basePrice {
              net
              gross
            }
            price {
              net
              gross
            }
            taxRate
            priceAdjustments {
              id
              uuid
              position
              promotionId
              campaignId
              couponId
              reasonCode
              lineitemText
              basePrice {
                net
                gross
              }
              price {
                net
                gross
              }
              attributes {
                attrId
                attrValue
              }
            }
            productId
            brand
            productName
            colorName
            sizeName
            qty {
              current
              ordered
              unallocated
              pending
              preExport
              preReExport
              canceled
              exported
              shipped
              unshipped
              inshipCanceled
              transfer
              receiveShipped
              receiveFixed
              exOut
              exOutExported
              exOutShipped
              exOutUnshipped
              exOutFixed
              exIn
              exInShipped
              exInFixed
            }
            unit
            orderItemType
            retailPrice
            isSale
            isGift
            point
            consumedPoint
            shipment {
              id
              uuid
            }
            isBundle
            preparingShipmentStartedAt
            releaseDatetime
            isShipment  
            bundleItems {
              id
              uuid
              auid
              position
              lineitemText
              productId
              preparingShipmentStartedAt
              releaseDatetime
              isShipment
              qty {
                current
                ordered
                unallocated
                pending
                preExport
                preReExport
                canceled
                exported
                shipped
                unshipped
                inshipCanceled
                transfer
                receiveShipped
                receiveFixed
                exOut
                exOutExported
                exOutShipped
                exOutUnshipped
                exOutFixed
                exIn
                exInShipped
                exInFixed
              }
              exchanges {
                id
                uuid
                orderExport {
                  id
                }
                srcOrderItem {
                  id
                  uuid
                  auid
                  position
                  lineitemText
                  productId
                }
                destOrderItem {
                  id
                  uuid
                  auid
                  position
                  lineitemText
                  productId
                }
                quantity
                preExportQty
                exportedQty
                shippedQty
                unshippedQty
                completedQty
                inshipCanceledQty
                isStockout
              }
              attributes {
                attrId
                attrValue
              }
            }
            attributes {
              attrId
              attrValue
            }
          }
          giftItems {
            id
            uuid
            auid
            position
            lineitemText
            basePrice {
              net
              gross
            }
            price {
              net
              gross
            }
            taxRate
            priceAdjustments {
              id
              uuid
              position
              promotionId
              campaignId
              couponId
              reasonCode
              lineitemText
              basePrice {
                net
                gross
              }
              price {
                net
                gross
              }
              attributes {
                attrId
                attrValue
              }
            }
            shipment {
              id
              uuid
            }
            attributes {
              attrId
              attrValue
            }
          }
          shippingItems {
            id
            uuid
            auid
            position
            lineitemText
            basePrice {
              net
              gross
            }
            price {
              net
              gross
            }
            taxRate
            priceAdjustments {
              id
              uuid
              position
              promotionId
              campaignId
              couponId
              reasonCode
              lineitemText
              basePrice {
                net
                gross
              }
              price {
                net
                gross
              }
              attributes {
                attrId
                attrValue
              }
            }
            shipment {
              id
              uuid
            }
            attributes {
              attrId
              attrValue
            }
          }
          attributes {
            attrId
            attrValue
          }
        }
        payments {
          id
          uuid
          auid
          position
          paymentMethod {
            code
            name
            nameAbbr
            methodType
            isImmediatable
          }
          amount
          transactionId1
          transactionId2
          transactionId3
          paidAt
          isPaid
          isProcessed
          editableType
          paymentSets {
            id
            uuid
            latestOrder {
              id
              uuid
            }
            orderPayment {
              id
              uuid
              paymentMethod {
                code
                name
                nameAbbr
                methodType
                isImmediatable
              }
            }
            processCode
            statusCode
            isReserved
            isCancellable
            processesAt
            processedAt
            amount
            requestedAt
            responsedAt
            responseCode
            responseKey
            responseKey2
            errorReasonCode
            createdAt
            updatedAt
            attributes {
              attrId
              attrValue
            }
          }
          attributes {
            attrId
            attrValue
          }
        }
        isPaid
        orderTotalPrice {
          net
          gross
        }
        merchandisePriceAdjustments {
          id
          uuid
          position
          promotionId
          campaignId
          couponId
          reasonCode
          lineitemText
          basePrice {
            net
            gross
          }
          price {
            net
            gross
          }
          attributes {
            attrId
            attrValue
          }
        }
        invoiceNo
        currency
        taxation
        businessType
        orderType
        channelType
        redResult
        point
        consumedPoint
        isLatest
        attributes {
          attrId
          attrValue
        }
      }
      attributes {
        attrId
        attrValue
      }
      mail {
        mailTemplate {
          templateName
        }
        scheduledSendAt
        sentAt
        createdAt
      }
      cooperate {
        apiName
        requestedAt
        responsedAt
        errorReasonCode
        createdAt
      }
    }
  }
`

/**
 * 注文詳細
 */
export const GRAPH_QL_QUERY_ORDER_DATETIME =
`
  query {
    latestOrder( ? ) {
      orderDatetime
    }
  }
`

/**
 * SKU属性
 */
export const GRAPH_QL_QUERY_SKU_ATTR =
`
  query {
    skus( ? ) {
      edges {
        node {
          code
          attributes {
            attrId
            attrValue
          }
        }
      }
      totalCount
    }
  }
`

/**
 * SKU一覧
 */
export const GRAPH_QL_QUERY_SKU_LIST =
`
  query {
    skus( ? , limit: 100) {
      edges {
        node {
          code
          name
          jan
          color {
            name
          }
          size {
            name
          }
          plus ( ? ) {
            priceExTax
            priceInTax
            saleType
          }
          product {
            code
            brand {
              name
            }
            name
            taxes ( ? ) {
              rate
            }
          }
          attributes {
            attrId
            attrValue
          }
        }
      }
      totalCount
    }
  }
`

/**
 * SKU一覧(品番展開する)
 */
export const GRAPH_QL_QUERY_SKU_LIST_EXPAND =
`
  query {
    skus( ? ) {
      edges {
        node {
          product {
            skus (?) {
              code
              jan
              color {
                name
              }
              size {
                name
              }
              plus ( ? ) {
                priceExTax
                priceInTax
                saleType
              }
              product {
                code
                brand {
                  name
                }
                name
                taxes ( ? ) {
                  rate
                }
              }
              attributes {
                attrId
                attrValue
              }
            }
          }
        }
      }
      totalCount
    }
  }
`

/**
 * 税率情報
 */
export const GRAPH_QL_QUERY_TAXES =
`
  query {
    taxes( ? ) {
      type
      rate
    }
  }
`

/**
 * 臨時出荷指図依頼一覧
 */

export const GRAPH_QL_QUERY_EXTRA_EXPORT_LIST =
`
  query {
    latestOrders( ? ) {
      edges {
        node {
          uuid
          orderNo
          site {
            code
            name
          }
          shipments {
            id
            uuid
            shipmentId
            receiver {
              lastName
              secondName
              firstName
              suffix
              lastNameKana
              firstNameKana
              phone
            }
            address {
              countryCode
              postalCode
              stateCode
              city
              address1
              address2
              suite
              postbox
            }
            shippingMethod
            giftType
            giftMessage
            deliveryDate
            deliveryTime
            items {
              id
              position
              lineitemText
              productId
              releaseDatetime
              preparingShipmentStartedAt
              isShipment
              basePrice {
                net
                gross
              }
              price {
                net
                gross
              }
              qty {
                current
                ordered
                unallocated
                pending
                preExport
                preReExport
                canceled
                exported
                shipped
                unshipped
                inshipCanceled
                transfer
                receiveShipped
                receiveFixed
                exOut
                exOutExported
                exOutShipped
                exOutUnshipped
                exOutFixed
                exIn
                exInShipped
                exInFixed
              }
            }
          }
        }
      }
      totalCount
    }
  }
`



// WEBPACK FOOTER //
// ./src/queries/order.js